'use client';

import classNames from 'classnames';
import { CalendarClock, CalendarDays, Info } from 'lucide-react';

interface ServiceAvailabilityProps {
  value: boolean | null;
  onChange: (value: boolean) => void;
  isSetup?: boolean;
}

export default function ServiceAvailability({ value, onChange, isSetup }: ServiceAvailabilityProps) {
  return (
    <div className="flex flex-col gap-6">
      <div className={classNames('space-y-1', { 'px-4 sm:px-0': !isSetup, '!self-center': isSetup })}>
        <h2 className="text-2xl font-medium text-gray-900">
          {isSetup ? 'Agrega tu primer servicio' : 'Formato de disponibilidad'}
        </h2>
        <p className="text-[#626262] text-sm">
          Selecciona cómo quieres gestionar la disponibilidad para este servicio
        </p>
      </div>

      <div className={classNames('space-y-4', { 'px-4 sm:px-0': !isSetup })}>
        <div
          className={`border-2 rounded-xl p-4 sm:p-5 cursor-pointer transition-all duration-200 ${
            value === false ? 'border-blue bg-blue/10' : 'border-gray-200 hover:border-blue/30'
          }`}
          onClick={() => onChange(false)}
        >
          <div className="flex flex-col sm:flex-row sm:items-start gap-3 sm:gap-4">
            <div className="flex items-center gap-3 sm:mt-1 sm:gap-4">
              <input
                type="radio"
                name="availability"
                checked={typeof value === 'boolean' && value === false}
                className="radio radio-sm border-gray-400 checked:border-blue"
              />
              <CalendarDays className="h-5 w-5 text-blue flex-shrink-0" />
            </div>
            <div className="flex-1 space-y-2">
              <span className="font-medium text-xl text-gray-900 block">
                Usar horarios de trabajo del profesional
              </span>
              <p className="text-[#626262] text-sm leading-relaxed">
                Este servicio estará disponible durante los horarios de trabajo configurados para cada
                profesional.
              </p>
            </div>
          </div>
        </div>

        <div
          className={`border-2 rounded-xl p-4 sm:p-5 cursor-pointer transition-all duration-200 ${
            value === true ? 'border-blue bg-blue/10' : 'border-gray-200 hover:border-blue/30'
          }`}
          onClick={() => onChange(true)}
        >
          <div className="flex flex-col sm:flex-row sm:items-start gap-3 sm:gap-4">
            <div className="flex items-center gap-3 sm:mt-1 sm:gap-4">
              <input
                type="radio"
                name="availability"
                checked={typeof value === 'boolean' && value === true}
                className="radio radio-sm border-gray-400 checked:border-blue"
              />
              <CalendarClock className="h-5 w-5 text-blue flex-shrink-0" />
            </div>
            <div className="flex-1 space-y-3">
              <span className="font-medium text-xl text-gray-900 block">
                Definir horarios específicos para este servicio
              </span>
              <p className="text-[#626262] text-sm leading-relaxed">
                Este servicio tendrá su propia disponibilidad, independiente de los horarios de trabajo del
                profesional.
              </p>
              <div className="flex items-start gap-2 bg-[#626262]/10 rounded-lg p-3">
                <Info className="h-4 w-4 text-gray-500 mt-0.5 flex-shrink-0" />
                <p className="text-gray-700 text-xs leading-relaxed">
                  Una vez creado el servicio podrás indicar los horarios disponibles desde tu Agenda. Este
                  servicio no será contemplado dentro de los horarios de trabajo regulares.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
